import React from "react";
//Child Comp
import { MovieTagCarousel } from "../../features/MovieTag/MovieTagCarousel.js";
//Styling
import "./CategoryShowcase.css";

export const CategoryShowcase = (props) => {
  let { categoryData } = props;
  console.log(categoryData);

  function customTitlte(rawData) {
    let { award, category, awardYear, winnerOnly } = rawData;

    let title = "${category} - ${award} - ${year} - ${winner}";
    title = title
      .replace("${category}", category.name)
      .replace("${award}", award.name)
      .replace(
        "${year}",
        awardYear.length == 1
          ? awardYear[0]
          : `from ${awardYear[0]} to ${awardYear[awardYear.length - 1]}`
      )
      .replace("${winner}", winnerOnly ? "Winner" : "All Nominees");
    return title;
  }

  let title = customTitlte(categoryData);
  let overview = categoryData.category.overview
    ? categoryData.category.overview
    : "UNK";
  let listOfIds = categoryData.nominees.map(
    (nominee) => nominee.movie.tmdbId.id
  );
  //Handle API Call

  return (
    <div className="category_showcase_wrapper">
      <div className="category_showcase category_background_wrapper">
        <div className="category_showcase_title">{title}</div>
        <div className="category_showcase_overview">{overview}</div>
      </div>
      <div className="category_showcase category_content_wrapper">
        <MovieTagCarousel
          isImage={true}
          movieItems={listOfIds}
          isGrid={true}
          isDefaultSmall={true}
          movieType={"mov"}
          isHoverEnable={true}
        />
      </div>
    </div>
  );
};
